import "../css/style.scss"

// General JS
import "./modules/general"

// Our modules / classes
import MobileMenu from "./modules/mobilemenu"
import GoToTopScroll from "./modules/gototop"

// Instantiate a new object using our modules/classes
const mobilemenu = new MobileMenu()
const gototopscroll = new GoToTopScroll()
